const schema = require('./order');
const { validateSchema } = require('../common/validate-schema');

function validateOrderSchema(request) {

    validateSchema(schema, request);
}

module.exports = {
    validateOrderSchema
};
